/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Validation_ErrorInputs */

const en_error_validation_error = /** @type {(inputs: Error_Validation_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some values are not valid.`)
};

/**
* | output |
* | --- |
* | "Some values are not valid." |
*
* @param {Error_Validation_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_validation_error = /** @type {((inputs?: Error_Validation_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Validation_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_validation_error(inputs)
});